import React from 'react'
import { Stack } from '@mui/material'

import { B2CRegistryActionButtons } from './components'
import { B2CRegistryFilters } from './components'
import { B2CRegistryRequestTable } from './table'

export const B2CRegistryPage = (): React.ReactElement => {
  return (
    <Stack gap={3}>
      <B2CRegistryActionButtons />
      <B2CRegistryFilters />
      <B2CRegistryRequestTable />
    </Stack>
  )
}
